const MARKUP = /<[a-z][^>]*>/i;
const collapseWhitespace = (text) => text.replaceAll(/\s+/g, ' ').trim();
const asText = (body) => MARKUP.test(body)
    ? collapseWhitespace(new DOMParser().parseFromString(body, 'text/html').body.textContent)
    : collapseWhitespace(body);
export const iapRefusalDetails = (status, body) => {
    const raw = typeof body === 'string' ? body : '';
    if (status === 401 && !MARKUP.test(raw)) {
        return null;
    }
    return {
        status: status ?? null,
        message: asText(raw)
    };
};
